// @ts-nocheck

import type { AnyAction, Dispatch } from 'redux';
import { v4 } from 'uuid';

import {
  addFavoriteOk,
  addFavoriteKo,
  delFavoriteOk,
  delFavoriteKo,
  purgeFavoritesOk,
  purgeFavoritesKo,
} from '../../actions/favorites';
import networkActions from '../../actions/network';
import { FavoriteActionTypes } from '../../types/actions/favorite';
import { type HandlerProps } from '../synchronousMiddleware';

const requests = {};

const handleSend = (dispatch: Dispatch<AnyAction>, action) => {
  const { id: transactionId } = action.optimist ?? {};
  const { matchId } = action.payload || {};
  const uniqId = v4();

  let message = null;
  if (FavoriteActionTypes.PURGE === action.type) {
    requests[uniqId] = { type: action.type, transactionId };
    message = {
      favorites: {
        method: 'purge',
        id: uniqId,
      },
    };
  } else if (matchId) {
    requests[uniqId] = { type: action.type, matchId, transactionId };
    message = {
      favorites: {
        method: 'toggle',
        params: { matchId },
        id: uniqId,
      },
    };
  }
  if (message) {
    dispatch(networkActions.send(message));
  }
};

const handleReceive = (dispatch: Dispatch<AnyAction>, action) => {
  const { id: uniqId, result } = action.payload ?? {};
  const request = requests[uniqId];
  if (request) {
    const { type: requestType, transactionId } = request;
    if (requestType === FavoriteActionTypes.ADD) {
      const { matchId } = request;
      if (result?.success) {
        dispatch(addFavoriteOk({ matchId, transactionId }));
      } else {
        dispatch(addFavoriteKo({ matchId, transactionId }));
      }
    }

    if (requestType === FavoriteActionTypes.DEL) {
      const { matchId } = request;
      if (result?.success) {
        dispatch(delFavoriteOk({ matchId, transactionId }));
      } else {
        dispatch(delFavoriteKo({ matchId, transactionId }));
      }
    }

    if (requestType === FavoriteActionTypes.PURGE) {
      if (result?.success) {
        dispatch(purgeFavoritesOk({ transactionId }));
      } else {
        dispatch(purgeFavoritesKo({ transactionId }));
      }
    }
    delete requests[transactionId];
  }
};

export const handledActionTypes = [
  FavoriteActionTypes.ADD,
  FavoriteActionTypes.DEL,
  FavoriteActionTypes.PURGE,
  FavoriteActionTypes.RECEIVE_RESPONSE,
];

const favoritesMiddlewareHandler = ({ store: { dispatch }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if ([FavoriteActionTypes.ADD, FavoriteActionTypes.DEL, FavoriteActionTypes.PURGE].indexOf(action.type) !== -1) {
      handleSend(dispatch, action);
    }

    if (action.type === FavoriteActionTypes.RECEIVE_RESPONSE) {
      handleReceive(dispatch, action);
    }
  }
};

export default favoritesMiddlewareHandler;
